const PRIVACY_OPT_OUT_STORAGE_KEY = "linkhiv:privacy-opt-out";

type NavigatorWithPrivacySignals = Navigator & {
  globalPrivacyControl?: boolean;
  msDoNotTrack?: string;
};

export const hasPrivacyOptOutSignal = (): boolean => {
  if (typeof window === "undefined") return false;

  const navigatorWithSignals = window.navigator as NavigatorWithPrivacySignals;
  if (navigatorWithSignals.globalPrivacyControl === true) return true;

  try {
    return window.localStorage.getItem(PRIVACY_OPT_OUT_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};
